/*
  Live store-wide review total from Yotpo (product + site reviews, the same figure Yotpo's
  dashboard shows). Fills [data-pmx-review-avg], [data-pmx-review-count] and
  [data-pmx-review-stars] (star fill width). The server-rendered values are the fallback, so a
  failed request just leaves them as they are. Cached per tab for an hour.
*/
(() => {
  const els = document.querySelectorAll('[data-pmx-review-avg],[data-pmx-review-count],[data-pmx-review-stars]');
  const key = window.PMX_YOTPO_KEY;
  if (!els.length || !key) return;

  const CACHE = 'pmx-review-total';
  const apply = ({ avg, count }) => {
    if (!(avg > 0) || !(count > 0)) return;
    document.querySelectorAll('[data-pmx-review-avg]').forEach((el) => { el.textContent = avg.toFixed(1); });
    document.querySelectorAll('[data-pmx-review-count]').forEach((el) => { el.textContent = count.toLocaleString('en-US'); });
    document.querySelectorAll('[data-pmx-review-stars]').forEach((el) => { el.style.width = Math.min(100, avg * 20) + '%'; });
  };

  try {
    const hit = JSON.parse(sessionStorage.getItem(CACHE) || 'null');
    if (hit && Date.now() - hit.at < 36e5) return apply(hit);
  } catch (e) {}

  fetch(`https://api-cdn.yotpo.com/products/${key}/yotpo_global_reviews/bottomline`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      const b = d && d.response && d.response.bottomline;
      if (!b) return;
      const total = { avg: Number(b.average_score), count: Number(b.total_reviews), at: Date.now() };
      apply(total);
      try { sessionStorage.setItem(CACHE, JSON.stringify(total)); } catch (e) {}
    })
    .catch(() => {});
})();
